<template>
    <card class="card">
        <div class="card-body">
            <h2 class="pt-0 mt-0">
                <i class="fas fa-file-alt text-primary"></i> {{$t('assessments.titleedit')}}
            </h2>
            <hr />
            <div>
                <form @submit.prevent>
                    <div class="row">
                      <div class="col-md-6">
                        <fg-input 
                          type="text" 
                          label="Título" 
                          v-model="assessments.title"
                        ></fg-input>
                      </div>
                      <div class="col-md-3 pt-4">
                        <div class="form-check">
                          <input
                          type="checkbox"
                          class="form-check-input"
                          value="1"
                          v-model="assessments.evaluate_by_rating"
                          id="evaluate_by_rating"
                          :disabled="assessments.use_evaluation == 1"
                          />
                          <label for="evaluate_by_rating">Calcular a pontuação do questionário em porcentagem ao invés de valor absoluto</label>
                        </div>
                      </div>
                      <div class="col-md-3 pt-4">
                        <div class="form-check">
                          <input
                          type="checkbox"
                          class="form-check-input"
                          value="1"
                          v-model="assessments.use_evaluation"
                          id="use_evaluation"
                          @click="assessments.evaluate_by_rating = true"
                          />
                          <label for="use_evaluation">Considerar questionário na pontuação do certificação da Assistência Técnica</label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                          <label for="datepicker_start_date">Data de início</label>
                          <b-form-datepicker
                            id="datepicker_start_date"
                            v-model="assessments.start_date"
                            class=""
                            :dark=true
                            :placeholder="$t('assessment.start_date')">
                          </b-form-datepicker>
                        </div>
                        <div class="col-md-6">
                          <label for="datepicker_end_date">Data de encerramento</label>
                          <b-form-datepicker
                            id="datepicker_end_date"
                            v-model="assessments.end_date"
                            class=""
                            :dark=true
                            :placeholder="$t('assessment.end_date')">
                          </b-form-datepicker>
                      </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label for="description">Descrição</label>
                            <textarea class="form-control" v-model="assessments.description"></textarea>
                          </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <h3 class="pt-0 mt-0">
                      <i class="fas fa-question text-primary"></i> Questões
                    </h3>
                    <hr />

                    <!-- Perguntas -->
                    <fg-question v-model="assessments.questions" :showButtons="false" :immediateWatch="true" />

                    <div class="text-left">
                        <p-button type="primary" @click.native.prevent="update">Save</p-button>
                    </div>
                    <div class="clearfix"></div>
                </form>
            </div>
        </div>
    </card>
</template>
<script>
import Multiselect from "vue-multiselect";
import deepmerge from "deepmerge";
import { mapState } from "vuex";

export default {
  // data() {
  //   return {
  //     assessments: {
  //       id: "",
  //       title: "",
  //       description: "",
  //       start_date: "",
  //       end_date: "",
  //       questions: []
  //     }
  //   };
  // },
  computed: {
    ...mapState("assessments", {
      assessments: "assessments"
    })
  },
  // watch: {
  //   assessments: function(newData) {
  //     this.assessments = deepmerge(this.assessments, newData, {
  //       arrayMerge: (destination, source) => {
  //         return [...destination, ...source];
  //       }
  //     });
  //   }
  // },
  created() {
    this.$store
      .dispatch("assessments/get", this.$route.params.id)
      .catch(error => {
        let msg = "";
        if (error.response.data) {
          msg = error.response.data.errors[0].detail;
        } else {
          msg = error.response.message;
        }
        this.$notify({
          type: "danger",
          horizontalAlign: "center",
          message: msg
        });
      });
    // console.log(this.assessments);
  },
  methods: {
    update() {
      // console.log(this.assessments);
      this.$store
        .dispatch("assessments/edit", this.assessments)
        .then(response => {
          this.$router.push({ name: "assessments" });
          this.$notify({
            type: "success",
            horizontalAlign: "center",
            message: "Assessment updated with success!"
          });
        })
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
    }
  }
};
</script>
<style>
</style>
